module.exports = __webpack_public_path__ + "img/13.a035d09b.png";